/** Bloques del mapa SEO — alineados con IA del sitio (nav, sitemap). Primera regla que encaja gana. */

export interface SeoPathBlock {
    id: string;
    name: string;
    prefixes: string[];
    exact: string[];
}

export const SEO_PATH_BLOCKS: SeoPathBlock[] = [
    { id: 'atlas', name: 'Atlas', prefixes: ['/atlas'], exact: [] },
    { id: 'blog', name: 'Blog', prefixes: ['/blog'], exact: [] },
    { id: 'academia', name: 'Academia', prefixes: ['/academia'], exact: [] },
    { id: 'licencias', name: 'Licencias de pesca', prefixes: ['/licencias-pesca'], exact: [] },
    { id: 'tienda', name: 'Tienda', prefixes: ['/tienda'], exact: [] },
    { id: 'clubes', name: 'Clubes', prefixes: ['/clubes'], exact: [] },
    { id: 'pescadores', name: 'Pescadores', prefixes: ['/pescadores'], exact: [] },
    { id: 'eventos', name: 'Eventos', prefixes: ['/eventos'], exact: [] },
    { id: 'colaboradores', name: 'Colaboradores', prefixes: ['/colaboradores'], exact: [] },
    { id: 'autores', name: 'Autores', prefixes: ['/autor'], exact: [] },
    {
        id: 'legal',
        name: 'Legal y soporte',
        prefixes: [],
        exact: [
            '/privacy-policy',
            '/terms-of-service',
            '/cookie-policy',
            '/support',
            '/account-deletion',
            '/metodologia-datos',
        ],
    },
    { id: 'marca', name: 'Marca e institucional', prefixes: [], exact: ['/', '/?utm_source=google'] },
];

const LICENSE_FLOW_SEGMENTS = new Set([
    'orden',
    'tramitar',
    'declaracion-navegacion',
    'atun-rojo',
]);

function prefixMatch(path: string, prefix: string): boolean {
    const base = prefix.replace(/\/$/, '');
    return path === base || path.startsWith(`${base}/`);
}

export function classifyLandingPath(path: string): string | null {
    for (const rule of SEO_PATH_BLOCKS) {
        if (rule.exact.includes(path)) return rule.id;
        if (rule.prefixes.some((prefix) => prefixMatch(path, prefix))) return rule.id;
    }
    return null;
}

export function seoBlockName(id: string | null): string {
    return SEO_PATH_BLOCKS.find((rule) => rule.id === id)?.name ?? 'Sin clasificar';
}

function humanizeSlug(slug: string): string {
    const text = slug.replace(/[-_]/g, ' ').trim();
    if (!text) return 'Inicio';
    return text.charAt(0).toUpperCase() + text.slice(1);
}

/** Segundo segmento de path con prefijo fijo, o null si es solo el índice. */
function secondSegment(path: string, prefix: string): string | null {
    const base = prefix.replace(/\/$/, '');
    if (path === base) return null;
    const rest = path.slice(base.length + 1);
    const seg = decodeURIComponent(rest.split('/')[0] || '');
    return seg || null;
}

export function licenseGroupLabel(path: string): string {
    if (path === '/licencias-pesca') return 'Índice';
    const seg = secondSegment(path, '/licencias-pesca');
    if (!seg) return 'Índice';
    if (LICENSE_FLOW_SEGMENTS.has(seg)) return 'Trámites y flujos';
    return humanizeSlug(seg);
}

export function authorGroupLabel(path: string): string {
    if (path === '/autor' || path.startsWith('/autor/') === false) return 'Índice';
    const seg = secondSegment(path, '/autor');
    return seg ? humanizeSlug(seg) : 'Índice';
}

export function collaboratorGroupLabel(path: string): string {
    if (path === '/colaboradores') return 'Índice';
    const seg = secondSegment(path, '/colaboradores');
    return seg ? humanizeSlug(seg) : 'Otras páginas';
}

export function academiaGroupLabel(path: string): string {
    return path === '/academia' ? 'Índice' : 'Contenido';
}

export const SEO_GROUP_TAIL = new Set([
    'Sin tipología',
    'Sin marca',
    'Otras páginas',
    'Trámites y flujos',
    'Contenido',
]);
